import {
  ERatePlanTax,
  ERatePlanTaxCapture,
  ERatePlanTaxCreditBrand,
} from "./rate-plan.type";

export enum EPendencyCategory {
  RATE = "RATE",
}

export enum EPendencyStatus {
  OPEN = "OPEN",
  RESOLVED = "RESOLVED",
  DISMISSED = "DISMISSED",
}

interface IPendencyBase {
  id: number;
  category: EPendencyCategory;
  title: string;
  status: EPendencyStatus;
  createdAt: string;
  updatedAt: string;
  context: unknown;
}

export enum EPendencyRateCode {
  NEGATIVE_RATE = "NEGATIVE_RATE",
  DEFAULT_RATE = "DEFAULT_RATE",
}

export interface IPendencyRateError {
  id: number;
  taxType: ERatePlanTax;
  captureType?: ERatePlanTaxCapture;
  brand?: ERatePlanTaxCreditBrand;
  installment?: number;
  delayForRedeem?: number;
  currentValue?: number;
  code: EPendencyRateCode;
  consentedByUser?: string | null;
  consentedAt?: string | null;
}

export interface IPendencyRateContext {
  markupId: number;
  sellerPlanTemplateId: number;
  sellerPlanTemplate: {
    name: string;
  };
  sellerId: number;
  seller: {
    name: string;
  };
  errors: IPendencyRateError[];
}

export interface IRatePendency extends IPendencyBase {
  category: EPendencyCategory.RATE;
  context: IPendencyRateContext;
}

export type IPendency = IRatePendency;

export interface IPendencyPagination {
  page: number;
  limit: number;
  total: number;
  pages: number;
}

export interface IPendencyWithPagination {
  data: IPendency[];
  pagination: IPendencyPagination;
}
